export enum UserRole {
	ClientAdmin = '3',
	Facilitator = '2',
	Participant = '1',
	SuperAdmin = '4',
}
